export class SubjectArea {
    subjectAreaId: number;
    subjectAreaName: string;
    diagramNotes: string;
    loadDate: string;
}
